import React from 'react';

const Loader = () => (
    <div className="loader-wrapper">
        <span className="loader">
            <span className="loader-inner" />
        </span>
    </div>
);

export default Loader;
